var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"80vh"}},[_c('v-col',{attrs:{"cols":"12","md":"4","lg":"4","xl":"4"}},[_c('div',[_c('AuthenticationFormComponent')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }